import Lottie, { type LottieComponentProps } from 'lottie-react'
import loadingJson from '@/assets/lottie/loading-lottie.json'

interface LottieLoadingProps extends Partial<LottieComponentProps> {
  className?: string
}

export function LottieLoading({ className, ...props }: LottieLoadingProps) {
  return (
    <div className={className}>
      <Lottie animationData={loadingJson} {...props} />
    </div>
  )
}
